import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { usePagination } from '../context/PaginationContext';
import axios from 'axios';

const Navbar = ({ user, setUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showDeleteInput, setShowDeleteInput] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');

  const { setCurrentPage } = usePagination();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = () => {
      const adminToken = localStorage.getItem('adminToken');
      setIsAdmin(!!adminToken);
    };

    checkAdmin();
    window.addEventListener('user-logged-in', checkAdmin);
    window.addEventListener('user-logged-out', checkAdmin);

    return () => {
      window.removeEventListener('user-logged-in', checkAdmin);
      window.removeEventListener('user-logged-out', checkAdmin);
    };
  }, []);

  useEffect(() => {
    const handleUserUpdate = () => {
      const storedUser = localStorage.getItem('user');
      if (!storedUser || storedUser === "undefined") {
        setUser(null);
        return;
      }
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Invalid JSON in localStorage for 'user':", storedUser);
        localStorage.removeItem('user'); // clean it up
        setUser(null);
      }
    };

    handleUserUpdate();

    window.addEventListener('user-logged-in', handleUserUpdate);
    window.addEventListener('user-logged-out', handleUserUpdate);

    return () => {
      window.removeEventListener('user-logged-in', handleUserUpdate);
      window.removeEventListener('user-logged-out', handleUserUpdate);
    };
  }, [setUser]);


  const toggleMenu = () => setIsOpen(!isOpen);

  const handleHomeClick = () => {
    setCurrentPage(1);
    setIsOpen(false);
    navigate('/');
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('adminToken');
    setUser(null);
    setIsAdmin(false);
    window.dispatchEvent(new Event('user-logged-out'));
    navigate('/');
  };
  const handleAccountDelete = async () => {
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        alert('User not authenticated');
        return;
      }
      
      //below line is for our system and below to below is for render api calls 
      // const response = await axios.delete('http://localhost:5000/api/auth/delete-account', {
        const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/users/delete-account`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          currentPassword: deletePassword,
        },
      });
  
      alert(response.data.message);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      setUser(null);
      navigate('/');
      window.dispatchEvent(new Event('user-logged-out'));
    } catch (error) {
      console.error('Account Deletion Error:', error.response?.data || error.message);
      alert(error.response?.data?.message || 'Error deleting account');
    }
  };
  
  const handlePasswordChange = async () => {
    try {
      const token = localStorage.getItem('token'); // 🔥 FIXED

      if (!token) {
        alert('User not authenticated');
        return;
      }
      //same below is for local system and below to below is for render link
      // const response = await axios.put(
      //   'http://localhost:5000/api/auth/update-password',
      const response = 
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/users/update-password`,
      
        {
          currentPassword: oldPassword,
          newPassword: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.message);
      setOldPassword('');
      setNewPassword('');
    } catch (error) {
      console.error('Password Change Error:', error.response?.data || error.message);
      alert(error.response?.data?.message || 'Error changing password');
    }
  };

  const handleEmailChange = async () => {
    try {
      const token = localStorage.getItem('token'); // 🔥 FIXED

      if (!token) {
        alert('User not authenticated');
        return;
      }
      //this also is same below for local system and below below is for render
      // const response = await axios.put(
      //   'http://localhost:5000/api/auth/update-email',
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-email`,      
        {
          newEmail: newEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.message);
      setNewEmail('');
    } catch (error) {
      console.error('Email Change Error:', error.response?.data || error.message);
      alert(error.response?.data?.message || 'Error changing email');
    }
  };



  return (
    <>
      <nav className="navbar">
        <div className="logo">
          <Link to="/">AI StudyMate</Link>
        </div>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          <Link to="/" onClick={handleHomeClick}>Home</Link>

          {!isAdmin && (
            <>
              <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
              <Link to="/about" onClick={() => setIsOpen(false)}>About Us</Link>
            </>
          )}

          {isAdmin && (
            <>
              <Link to="/admin/dashboard" onClick={() => setIsOpen(false)}>Dashboard</Link>
              <Link to="/admin/subscribers" onClick={() => setIsOpen(false)}>Subscribed Users</Link>
              <Link to="/admin/users" onClick={() => setIsOpen(false)}>Users Data</Link>
              <Link to="/admin/messages" onClick={() => setIsOpen(false)}>Messages</Link>
            </>
          )}

          {user && !isAdmin ? (
            <>
              <button onClick={() => setShowSettings(!showSettings)} className="settings-btn">
                User Settings
              </button>
              <span>{user.name}</span>
              <button onClick={handleLogout} className="logout-btn">Logout</button>
            </>
          ) : isAdmin ? (
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          ) : (
            <Link to="/login" onClick={() => setIsOpen(false)}>Login</Link>
          )}
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <div className={`bar ${isOpen ? 'rotate-top' : ''}`}></div>
          <div className={`bar ${isOpen ? 'fade-out' : ''}`}></div>
          <div className={`bar ${isOpen ? 'rotate-bottom' : ''}`}></div>
        </div>
      </nav>

      {showSettings && user && !isAdmin && (
        <div className="user-settings-section">
          <div className="settings-buttons-row">
            <button onClick={() => {
              setShowEmailInput(!showEmailInput);
              setShowPasswordInput(false);
            }}>Change Email</button>

            <button onClick={() => {
              setShowPasswordInput(!showPasswordInput);
              setShowEmailInput(false);
            }}>Change Password</button>
            <button onClick={() => {
              setShowDeleteInput(!showDeleteInput);
              setShowEmailInput(false);
              setShowPasswordInput(false);
            }}>
              Delete Account
            </button>

          </div>

          {showEmailInput && (
            <div className="email-change-row">
              <label>Enter New Email:</label>
              <input
                type="email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
              />
              <button onClick={handleEmailChange}>Update Email</button>
            </div>
          )}

          {showPasswordInput && (
            <div className="password-change-row">
              <label>Old Password:</label>
              <input
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <label>New Password:</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button onClick={handlePasswordChange}>Update Password</button>
            </div>
          )}
          {showDeleteInput && (
            <div className="delete-account-row">
              <label>Enter Password to Confirm:</label>
              <input
                type="password"
                value={deletePassword}
                onChange={(e) => setDeletePassword(e.target.value)}
              />
              <button onClick={handleAccountDelete}>Confirm Delete</button>
            </div>
          )}

        </div>
      )}
    </>
  );
};

export default Navbar;
